<template>
  <!-- w-14 h-13 -->
  <path d='M1 6.5H12.5' stroke='#1C498E' stroke-width='1.5' stroke-linecap='round' />
  <path d='M6.75 0.75L6.75 12.25' stroke='#1C498E' stroke-width='1.5' stroke-linecap='round' />
</template>
